import { ExitScenarioInputDto } from '@app/shared/models/contracts/project-dto';

/** Key of the column the table renders before any scenario has been stored. */
export const DEFAULT_SCENARIO_KEY = '0';

export const sortScenarioKeys = (scenarios: Dictionary<ExitScenarioInputDto>): string[] =>
  Object.keys(scenarios).sort((a, b) => Number(a) - Number(b));

/**
 * The scenario keys used as the table's columns. The table always shows at least one column,
 * so an empty set of scenarios falls back to the default column.
 */
export const getScenarioColumnKeys = (scenarios: Dictionary<ExitScenarioInputDto>): string[] => {
  const scenarioKeys = sortScenarioKeys(scenarios);
  return scenarioKeys.length > 0 ? scenarioKeys : [DEFAULT_SCENARIO_KEY];
};

export const getNextScenarioKey = (scenarios: Dictionary<ExitScenarioInputDto>): string =>
  String(Math.max(...getScenarioColumnKeys(scenarios).map(Number)) + 1);

/**
 * Stable representation of the scenario inputs, used to tell whether anything actually changed
 * before re-running the calculation.
 */
export const getScenarioSignature = (scenarios: Dictionary<ExitScenarioInputDto>): string =>
  JSON.stringify(
    sortScenarioKeys(scenarios).map((key) => ({
      exitDate: scenarios[key]?.exitDate ?? '',
      enterpriseValue: scenarios[key]?.enterpriseValue ?? null,
    }))
  );
